// extracted by mini-css-extract-plugin
module.exports = {"focus-ring":"base_focus-ring__3sN35"};